import { getSite } from '@/api'
import { getIsCn } from '@/utils/region'

let siteData = null
let sitePromise = null

// is_cn / region 一律以客户端探测（region.js）为准，忽略 /api/site 返回值。
function regionFields() {
  const isCn = getIsCn()
  return { is_cn: isCn, region: isCn ? 'cn' : 'os' }
}

export function createDefaultSite() {
  return {
    name: '中文互联网拯救计划',
    intro: '随着各大 App 形成数据孤岛，中文互联网生态岌岌可危。\n本论坛全托管，您发布的内容只会通过大模型审核，有用的信息才会被通过。\n在这里你可以发布任意内容，当然需遵守中国法律；如果发布敏感内容，将仅海外 IP 可见。\n论坛主旨：留存真实有效的数据，为中文互联网做贡献。',
    site_open: true,
    site_notice: '',
    comment_hot_threshold: 10,
    ...regionFields(),
  }
}

export function getCachedSite() {
  return siteData
}

export async function getSiteData() {
  if (siteData) return siteData
  if (!sitePromise) {
    sitePromise = getSite()
      .then((res) => {
        // 合并后再次覆盖 is_cn/region：以客户端探测为准，忽略服务端返回值
        siteData = { ...createDefaultSite(), ...(res.data || {}), ...regionFields() }
        return siteData
      })
      .catch((err) => {
        sitePromise = null
        throw err
      })
  }
  return sitePromise
}

export function setSiteData(data) {
  siteData = { ...createDefaultSite(), ...(data || {}), ...regionFields() }
  return siteData
}
